export const itemsByCategory = {
  default: {
    defaultValue: null,
    items: [
      'ground', // Наземная
      'multilevel', // Многоуровневая
      'underground', // Подземная
      'roof', // На крыше
    ],
  },
  garage: {
    defaultValue: null,
    items: [
      'roof', // На крыше
      'underground', // Подземная
      'ground', // Наземная
      'multilevel', // Многоуровневая
      'open', // Открытая
    ],
  },
};

export default [
  {
    name: 'Наземная',
    key: 'ground',
  },
  {
    name: 'Многоуровневая',
    key: 'multilevel',
  },
  {
    name: 'Подземная',
    key: 'underground',
  },
  {
    name: 'На крыше',
    key: 'roof',
  },
  {
    name: 'Открытая',
    key: 'open',
  },
];
